module.exports = __webpack_public_path__ + "static/media/download-report.75c99b4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/download-report.svg
// module id = 1212
// module chunks = 0